export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'container',
              name: 'Container Serviços',
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'columnsService2',
                },
      
              ],
              styles: `
             .container-cubo{
                max-width: 1600px; 
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};